import styled from "styled-components";
import theme from "../common/theme";

export const Container = styled.div`
    border-top: 2px solid ${theme.palette.border};
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const Attribute = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`